export default __webpack_public_path__ + "static/media/avatar_alison7.549a43c3.mp3";